<template>
	<div :id="id" class="position-relative filter-container">
		<template v-if="typeFilter === 'date'">
			<div>
				<h3 class="title">Select period</h3>
				<v-date-picker
						width="270"
						color="green"
						class="picker-table"
						v-model="dates"
						@input="changeFilter($event, 'date')"
						range
				></v-date-picker>
			</div>
		</template>
		<div
				v-else-if="typeFilter === 'number'"
				class="numberWR"
		>
			<type-number
					:filterName="modelFilter"
					@updateNumber="onChangeNumber"
			></type-number>
		</div>

		<v-combobox
				v-else
				v-model="select"
				:items="getNumberToString"
				:label="'Select ' + labelFilter"
				class="green-icon"
				color="green"
				ref="combo"
				:attach="'#' + id"
				:menu-props="{ contentClass: 'filter-dd',  maxWidth: 270, minWidth: 270, nudgeWidth: 270 }"
				@input="changeFilter($event, 'select')"
				@blur="unDetect($event)"
				multiple
				clearable
				small-chips
				deletable-chips
				chips
		></v-combobox>
	</div>
</template>
<script>
import TypeNumber from "@/shared/table/filter-table/TypeNumber/TypeNumber";

export default {
	components: {
		TypeNumber
	},
	props: {
		dataFilter: {
			type: Array
		},
		modelFilter: {
			type: String,
			default: ''
		},
		filterUpdate: {
			type: Boolean
		},
		labelFilter: {
			type: String
		},
		uniqId: Object,
		typeFilter: {
			type: String,
			default: 'list'
		},
	},
	data() {
		return {
			select: [],
			dates: [],
		};
	},
	computed: {
		getNumberToString() {
			const items = this.items.map(item => {
				return item + '';
			});
			return items;
		},
		items() {
			return this.dataFilter.filter((value) => value != null && value);
		},
		id() {
			return "dd" + Math.round((Math.random() * (1000 - 20)) + 10);
		},
		update() {
			return this.filterUpdate;
		},
	},
	methods: {
		onChangeNumber(values) {
			const model = this.typeFilter;
			const { name, type } = values;
			const key = `filter_${ name }`;
			const value = { type, value: values.value };

			this.$emit("change-sort", { key, value, model });
		},
		unDetect(e) {
			e.target.value = '';
			this.$refs.combo.internalSearch = null;
			this.$refs.combo.lazySearch = null;
		},
		changeFilter(e, key) {
			if (e.length > 1 && key === "date") {
				const arr = e.sort((a, b) => {
					return new Date(a) - new Date(b);
				});
				this.$emit("change-sort", { key: this.modelFilter, value: arr, model: 'date' });
			} else if (key === "select") {
				this.$emit("change-sort", { key: this.modelFilter, value: e, model: 'list' });
			}
			this.$emit("filter-created", this.modelFilter);
		}
	},
	mounted() {
		this.$emit("filter-created", this.modelFilter);
	},
	watch: {
		uniqId(val, oldVal) {
			const { id, key } = val;
			const { id: oldId } = oldVal;
			if (id !== oldId && this.modelFilter === key) {
				this.select = Array.from(new Set(this.items.map(item => item.trim())));
				this.$emit("change-sort", { key: this.modelFilter, value: this.select });
			}
		},
		update(val) {
			if (val) {
				this.select = [];
				this.dates = [];
				this.$emit("create-refresh", this.modelFilter);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.filter-container {
	.numberWR {
		padding-top: 15px;
	}
}
</style>
<style lang="scss">
@import "./filter-table";
</style>
